export interface EnvironmentConfig {
  production: boolean;
  RootDomain: string;
  AppDomain: string;
  ApiUrl: string;
  NewApiUrl: string;
  ApiUrlV2: string;
}

export const environmentConfigs: { [key: string]: EnvironmentConfig } = {
  'dev': {
    production: false,
    RootDomain: "glamera.com",
    AppDomain: "dev.glamera.com",
    ApiUrl: "https://api-dev.glamera.com/api/",
    NewApiUrl: "https://api-dev-new.glamera.com/api/",
    ApiUrlV2: "https://api-dev.glamera.com/api/v2/"
  },
  'stage': {
    production: false,
    RootDomain: "glamera.com",
    AppDomain: "stage.glamera.com",
    ApiUrl: "https://api-stage.glamera.com/api/",
    NewApiUrl: "https://api-stage-new.glamera.com/api/",
    ApiUrlV2: "https://api-stage.glamera.com/api/v2/"
  },
  'prodump': {
    production: false,
    RootDomain: "glamera.com",
    AppDomain: "prodump.glamera.com",
    ApiUrl: "https://api-production-dump.glamera.com/api/",
    NewApiUrl: "https://api-prodump-new.glamera.com/api/",
    ApiUrlV2: "https://api-production-dump.glamera.com/api/v2/"
  },
  'pro': {
    production: true,
    RootDomain: "glamera.com",
    AppDomain: "pro.glamera.com",
    ApiUrl: "https://api-sys.glamera.com/api/",
    NewApiUrl: "https://api-sys.glamera.com/api/",
    ApiUrlV2: "https://api-sys.glamera.com/api/v2/"
  },
  'app': {
    production: true,
    RootDomain: "glamera.com",
    AppDomain: "app.glamera.com",
    ApiUrl: "https://api-sys.glamera.com/api/",
    NewApiUrl: "https://api-sys.glamera.com/api/",
    ApiUrlV2: "https://api-sys.glamera.com/api/v2/"
  },
  'sys': {
    production: true,
    RootDomain: "glamera.com",
    AppDomain: "sys.glamera.com",
    ApiUrl: "https://api-sys.glamera.com/api/",
    NewApiUrl: "https://api-sys.glamera.com/api/",
    ApiUrlV2: "https://api-sys.glamera.com/api/v2/"
  },
  'live': {
    production: true,
    RootDomain: "glamera.com",
    AppDomain: "live.glamera.com",
    ApiUrl: "https://api-newproduction.glamera.com/api/",
    NewApiUrl: "https://api-glamerapro-new.glamera.com/api/",
    ApiUrlV2: "https://api-newproduction.glamera.com/api/v2/"
  }
};
